<template>
  <div class="window">
    <div class="data_info cursorpointer" v-for="(item, index) in dataInfo" :key="index" @click="changeTab(item,index)">
      <div class="num">
        <!-- <span>{{ item.num }}</span> -->
        {{ item.num }}
      </div>
      <div class="tit">{{ item.name }}<br />（{{ item.unit }}）</div>
    </div>

    <!-- <div class="jc cursorpointer">在线监控</div> -->
  </div>
</template>
<script>
export default {
  props: ['nowArea'],
  created() {
    this.getData()
  },
  watch: {
    nowArea(val) {
      console.log('userInfo', val)
      if (val[1] == '温州市') {
        this.dataInfo[0].name = '入驻用户'
      } else {
        this.dataInfo[0].name = '入驻企业'
      }
      this.getData()
    }
  },
  data() {
    return {
      dataInfo: [
        {
          name: "入驻企业",
          unit: "家",
          num: 98,
        },
        {
          name: "运输车辆",
          unit: "辆",
          num: 65,
        },
        {
          name: "库存量",
          unit: "吨",
          num: 14,
        },
        {
          name: "今日回收量",
          unit: "吨",
          num: 21,
        },
        {
          name: "累计回收量",
          unit: "吨",
          num: 98,
        },
        {
          name: "今日销量",
          unit: "吨",
          num: 12,
        },
        {
          name: "累计销量",
          unit: "吨",
          num: 10.2,
        },
        {
          name: "今日加工量",
          unit: "吨",
          num: 10.2,
        },
        {
          name: "累计加工量",
          unit: "吨",
          num: 10.2,
        },
      ],
    };
  },

  methods: {
    changeTab(item, index) {
      this.$emit('change', item, index)
    },
    getData() {
      this.$axios.get(`/screen/screen/city/carNum?province=${this.nowArea[0]}&city=${this.nowArea[1] || ''}`).then(res => {
        this.dataInfo[1].num = res.data.data.num
      })
      this.$axios.get(`/screen/screen/city/companyNum?province=${this.nowArea[0]}&city=${this.nowArea[1] || ''}`).then(res => {
        this.dataInfo[0].num = res.data.data.num
      })
      this.$axios.get(`/screen/screen/city/recovery?province=${this.nowArea[0]}&city=${this.nowArea[1] || ''}`).then(res => {
        this.dataInfo[3].num = res.data.data.recoveryToday
        this.dataInfo[4].num = res.data.data.recoveryTotal
      })
    }
  }
};
</script>
<style lang="scss" scoped>
.window {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  position: relative;
  padding: 10px 0;

  .jc {
    position: absolute;
    top: 5px;
    right: 20px;
    color: #fff;
  }

  .data_info {
    width: calc(100% / 9);
    text-align: center;
    color: #fff;

    .num {
      // max-width: 6em;
      // span:nth-child(1) {
      //   font-family: "yjsz";
      //   color: #00fbfe;
      //   text-shadow: 0 0 25px #00fbfe;
      //   font-size: 28px;
      //   font-weight: bolder;
      // }
      text-align: center;
      font-family: "yjsz";
      color: #00fbfe;
      text-shadow: 0 0 25px #00fbfe;
      font-size: 28px;
      font-weight: bolder;
    }

    .tit {

      
    }
  }
}
</style>